module.exports = __webpack_public_path__ + "files/df2115728c14a261a01b43bc74bb29b7.png";